import { render, staticRenderFns } from "./ModalDistribucion.vue?vue&type=template&id=101b416e&"
import script from "./ModalDistribucion.vue?vue&type=script&lang=js&"
export * from "./ModalDistribucion.vue?vue&type=script&lang=js&"
import style0 from "./ModalDistribucion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports